class EventHandler {
	constructor() {
		// this.props = props;
		this.handleSocketData = null;
	}

	set_event_handler = (handleSocketData) => {
		this.handleSocketData = handleSocketData;
	};
}

export default EventHandler;